import videojs from 'video.js';
import getSearch from '@src/Data/DataSource/Search';

const Plugin = videojs.getPlugin('plugin');
const Button = videojs.getComponent('MenuButton');

class SearchButtonPlugin extends Plugin {
  constructor(player, options) {
    super(player);

    const self = this;
    self.playerId = this.player.id();
    self.panelId = self.playerId + '-scaleup-search-panel';
    self.toggleSearch = () => {
      const element = document.getElementById(self.panelId);
      element.parentNode.classList.toggle('toggle-search');
    };

    self.closeSearch = () => {
      const element = document.getElementById(self.panelId);
      element.parentNode.classList.remove('toggle-search');
    };

    this.options = {...options};
    this.player.ready(() => {
      if (this.options.enableSearchButton) {
        this.player.addClass('scaleup-search-button');
        const searchPanelWrapper = videojs.dom.createEl('div');
        searchPanelWrapper.className = 'scaleup-search scaleup-search-display';
        searchPanelWrapper.id = self.playerId + '-scaleup-search-display';
        const searchPanelDiv = videojs.dom.createEl('div');
        searchPanelDiv.className = 'scaleup-search scaleup-search-panel';
        searchPanelDiv.id = self.playerId + '-scaleup-search-panel';
        searchPanelWrapper.appendChild(searchPanelDiv);
        self.player.el().appendChild(searchPanelWrapper);
        this.buildUI();
      }
    });

    this.player.on('click', evt => {
      const element = document.getElementById(self.panelId);

      if (element && !element.contains(evt.target) && !evt.target.classList.contains('scaleup-search')) {
        element.parentNode.classList.remove('toggle-search');
      }
    });
  }

  buildUI() {
    const self = this;
    const code = self.options.mediaCode;
    const auth = self.options.authorization;

    const searchPanelDiv = document.getElementById(self.playerId + '-scaleup-search-panel');

    this.searchText = '';

    class SearchButton extends Button {
      constructor(player, options) {
        super(player, options);
        this.addClass('scaleup-search-button');
        this.menuButton_.addClass('scaleup-search');
        this.controlText('Carregando');

        let that = this;

        self.player.one('canplaythrough', function (_event) {
          that.controlText('Busca');
        });
        this.menu.contentEl_.id = `${self.playerId}-scaleup-search-button-default`;
        this.buildPanel();
      }

      handleClick() {
        this.menu.el().classList.toggle('vjs-lock-open');
        this.el().classList.toggle('vjs-toogle-btn');

        if (self.options.onChangeSearch) {
          self.options.onChangeSearch();
        }

        if (searchPanelDiv.parentNode?.classList?.contains('toggle-search')) {
          searchPanelDiv.parentNode.classList.remove('toggle-search');
        } else {
          searchPanelDiv.parentNode.classList.add('toggle-search');
          self.player.pause();

          setTimeout(() => {
            document.querySelector('#scaleup-search__input').focus();
          }, 500);
        }
      }

      buildPanel() {
        const searchPanelContentWrapper = videojs.dom.createEl('div', {
          className: 'scaleup-search scaleup-search__panel-wrapper',
        });

        function debounce(func, timeout = 300) {
          let timer;
          return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
              func.apply(this, args);
            }, timeout);
          };
        }

        const searchPanelInput = videojs.dom.createEl('input', {
          className: 'scaleup-search__input',
          id: 'scaleup-search__input',
          autocomplete: 'off',
          placeholder: 'Pesquise algo',
          onkeyup: debounce(() => {
            this.searchText = searchPanelInput.value;
            this.getSearchContent(code, this.searchText, auth).then(response => {
              this.buildSearchReturn(searchPanelSearchResultsWrapper, response, this.searchText);
            });
          }, 300),
        });

        searchPanelInput.addEventListener('keydown', event => {
          const forbiddenKeys = ['/', '[', ']', '{', '}', '<', '>', '#', '%', '^', '*', '|', '\\'];
          if (forbiddenKeys.includes(event.key)) {
            event.preventDefault();
          }
        });

        const searchsearchPanelInputCloseButton = videojs.dom.createEl('button', {
          className: 'scaleup-search__input--close__button',
          onclick: () => {
            self.toggleSearch();
          },
        });

        const searchPanelInputCloseIcon = videojs.dom.createEl('button', {
          className: 'scaleup-search__input--close_button__icon fa-sharp fa-regular fa-xmark',
        });
        const searchPanelInputWrapper = videojs.dom.createEl('div', {
          className: 'scaleup-search scaleup-search__input-wrapper',
        });
        const searchPanelSearchResultsWrapper = videojs.dom.createEl('div', {
          className: 'scaleup-search scaleup-search__results-wrapper',
        });
        searchsearchPanelInputCloseButton.appendChild(searchPanelInputCloseIcon);
        searchPanelInputWrapper.appendChild(searchPanelInput);
        searchPanelInputWrapper.appendChild(searchsearchPanelInputCloseButton);
        searchPanelContentWrapper.appendChild(searchPanelInputWrapper);
        searchPanelContentWrapper.appendChild(searchPanelSearchResultsWrapper);
        searchPanelDiv.appendChild(searchPanelContentWrapper);
      }

      async getSearchContent(mediaCode, keyword, auth) {
        const parameters = {
          mediaCode: mediaCode,
          keyword: keyword,
          authorization: auth,
        };

        try {
          return await getSearch(parameters).then(response => {
            if (response.success) {
              return response;
            } else {
              return response;
            }
          });
        } catch (error) {
          console.error(error);
          return {
            success: false,
            message: error.message,
          };
        }
      }

      caseInsensitiveReplace = (source, searchValue, replacement) => {
        const regex = new RegExp(searchValue, 'giu');
        return source.replace(regex, match => {
          const isUpper = match.toUpperCase() === match;
          const isLower = match.toLowerCase() === match;
          const isFirstCharUpper = match[0].toUpperCase() === match[0];

          if (isUpper) {
            return `<span class="scaleup-search__results--highlight">${replacement.toUpperCase()}</span>`;
          } else if (isLower) {
            return `<span class="scaleup-search__results--highlight">${replacement.toLowerCase()}</span>`;
          } else if (isFirstCharUpper) {
            return `<span class="scaleup-search__results--highlight">${
              replacement.charAt(0).toUpperCase() + replacement.slice(1)
            }</span>`;
          } else {
            return `<span class="scaleup-search__results--highlight">${replacement}</span>`;
          }
        });
      };

      buildSearchReturn(searchPanelSearchResultsWrapper, response, keyword) {
        searchPanelSearchResultsWrapper.innerHTML = '';
        searchPanelSearchResultsWrapper.classList.remove('.scaleup-search__results--empty');

        if (response.success) {
          Object.values(response.content).forEach(answer => {
            const formattedAnswer = this.caseInsensitiveReplace(answer.text, this.searchText, keyword);
            const searchPanelSearchResultList = videojs.dom.createEl('li', {
              className: 'scaleup-search__results--list',
              tabIndex: '0',
              id: answer.id,
              onkeyup: e => (e.key === 'Enter' ? jumpTo(answer.startTime) : ''),
              onclick: () => {
                jumpTo(answer.startTime);
              },
            });
            searchPanelSearchResultsWrapper.classList.remove('scaleup-search__results--empty__wrapper');
            searchPanelSearchResultsWrapper.appendChild(searchPanelSearchResultList);
            searchPanelSearchResultList.innerHTML += `
            <p class="scaleup-search__results--text">
              ${formattedAnswer}
            </p>
            <span class="scaleup-search__results--start-time">
              ${videojs.formatTime(answer.startTime)}
            </span>
          `;
          });
        } else {
          searchPanelSearchResultsWrapper.classList.add('scaleup-search__results--empty__wrapper');
          searchPanelSearchResultsWrapper.innerHTML = `
             <i class="scaleup-search__results--empty fa-duotone fa-message-slash"></i>
             <span class="scaleup-search__results--empty">
               Nenhum resultado encontrado
             </span>
           `;
          return;
        }
      }
    }

    const jumpTo = time => {
      if (this.player) {
        this.player.currentTime(time);
        this.player.play();
        this.toggleSearch();
      }
    };

    videojs.registerComponent('searchButton', SearchButton);
    this.player.getChild('controlBar').addChild('searchButton');
    const searchIcon = videojs.dom.createEl('i', {
      className: 'fa-solid fa-magnifying-glass',
    });
    const searchButton = this.player.getChild('controlBar').getChild('searchButton');
    videojs.dom.prependTo(searchIcon, searchButton.el());
    if (this.player.getChild('controlBar').getChild('subsCapsButton')) {
      this.player
        .getChild('controlBar')
        .el()
        .insertBefore(
          this.player.getChild('controlBar').getChild('searchButton').el(),
          this.player.getChild('controlBar').getChild('subsCapsButton').el(),
        );
    } else {
      this.player
        .getChild('controlBar')
        .el()
        .insertBefore(
          this.player.getChild('controlBar').getChild('searchButton').el(),
          this.player.getChild('controlBar').getChild('settingsMenuButton').el(),
        );
    }

    function isMobileDevice() {
      return videojs.browser.IS_IOS || videojs.browser.IS_ANDROID;
    }
  }
}

SearchButtonPlugin.defaultState = {};

videojs.registerPlugin('searchButtonPlugin', SearchButtonPlugin);

export default SearchButtonPlugin;
